const MAP = {
  Pending: "bg-slate-100 text-slate-700",
  "Payment Received": "bg-blue-100 text-blue-800",
  Processing: "bg-indigo-100 text-indigo-800",
  "Document Found": "bg-cyan-100 text-cyan-800",
  Verification: "bg-amber-100 text-amber-800",
  Ready: "bg-emerald-100 text-emerald-800",
  Delivered: "bg-green-600 text-white",
  Cancelled: "bg-red-100 text-red-700",
};

export function StatusPill({ status }) {
  return (
    <span data-testid={`status-${(status || "").replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${MAP[status] || "bg-slate-100 text-slate-700"}`}>
      {status}
    </span>
  );
}

export function VerificationBadge({ level }) {
  const m = {
    GREEN: "bg-green-100 text-green-800 border-green-300",
    YELLOW: "bg-amber-100 text-amber-800 border-amber-300",
    RED: "bg-red-100 text-red-800 border-red-300",
  };
  const label = {
    GREEN: "GREEN — Information found / no issue identified",
    YELLOW: "YELLOW — Further verification required",
    RED: "RED — Potential issue / professional review recommended",
  };
  return (
    <span data-testid={`verification-badge-${(level || "").toLowerCase()}`}
      className={`inline-block px-3 py-1.5 rounded-lg border text-sm font-bold ${m[level] || m.YELLOW}`}>
      {label[level] || level}
    </span>
  );
}
